/** UI collection-method values (mapped to API on submit). */
export enum MGBCollectionMethod {
  Unset = '',
  Prepaid = 'Prepaid',
  Collect = 'Collect',
  ThirdParty = 'ThirdParty',
}

/** Load note type API values (no spaces — sent on create/update). */
export enum MGBLoadNoteType {
  InternalNote = 'InternalNote',
  SpecialInstructions = 'SpecialInstructions',
}

/**
 * Customer line-haul rate unit (MG price sheet).
 * `PerMile` / spaced / mileage aliases = Rate Per Mile mode.
 */
export enum MGBLineHaulUnit {
  Flat = 'FR',
  PerMile = 'PM',
  PerMileLabel = 'PER MILE',
  Mileage = 'MILEAGE',
}
